import { carConfigurationActions } from '../../store/reducers/carConfigurationReducer';
import { useDispatch, useSelector } from 'react-redux';
import carConfigurationSelectors from '../../store/selectors/carConfigurationSelectors';
import { useCallback } from 'react';
import accessoryService from '../../service/accessoryService';
import { optionsActions } from '../../store/reducers/optionsReducer';
import optionsSelectors from '../../store/selectors/optionsSelectors';

const useSelectedAccessories = () => {
  const dispatch = useDispatch();
  const currentSelectedAccessories = useSelector(carConfigurationSelectors.getSelectedAccessories);
  const accessoriesCategories = useSelector(optionsSelectors.getAccessoriesCategories);

  const setAndReturnAccessories = useCallback(
    (option: string) => {
      let accessories: string[];
      if (currentSelectedAccessories?.includes(option)) {
        const selectedCategories = accessoryService.getSelectedCategories(accessoriesCategories, option, false);
        dispatch(optionsActions.setAccessoriesCategories(selectedCategories));
        dispatch(carConfigurationActions.removeAccessory(option));
        accessories = currentSelectedAccessories.filter((accessory: string) => accessory !== option);
      } else {
        const selectedCategories = accessoryService.getSelectedCategories(accessoriesCategories, option, true);
        dispatch(optionsActions.setAccessoriesCategories(selectedCategories));
        dispatch(carConfigurationActions.addAccessory(option));
        accessories = [...currentSelectedAccessories, option];
      }

      return accessories;
    },
    [currentSelectedAccessories, accessoriesCategories],
  );

  return { setAndReturnAccessories };
};

export default useSelectedAccessories;
